<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import HeroButton from './HeroButton.svelte';
  export let phoneNumber: string;

  const dispatch = createEventDispatcher();
</script>

<div
  class="flex h-full w-full flex-col items-center justify-center gap-5 rounded-3xl bg-[#B3D18433] px-4 py-5 md:gap-20 md:py-10"
>
  <div class="flex flex-col items-center justify-center gap-3">
    <h3 class="text-2xl !font-bold leading-[1.3] text-[#161C24] md:text-[32px]">
      How can we help?
    </h3>
    <p class="leading-normal text-[#111111A3]">
      Choose the option that best fits your needs
    </p>
  </div>
  <div class="flex flex-col items-stretch justify-center gap-2.5">
    <HeroButton
      text="Start Your Quote Online"
      iconName="quote"
      onClick={() => dispatch('nextStep', { step: 'third', showSteps: true })}
    />
    <HeroButton
      text="Send Us a Message"
      iconName="message-custom"
      onClick={() =>
        dispatch('nextStep', { step: 'form-data', showSteps: false })}
    />
    <HeroButton
      text="Call Us Now"
      iconName="call"
      href={`tel:${phoneNumber}`}
    />
  </div>
</div>
